import React from "react"

import BackgroundImage from "../../../common/BackgroundImage"
import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"
import { languageCodeMapping } from "../../../../config/language-definitions"

const ViewFeedItemPublishingDetails = ({
    publisher,
    link,
    title,
    time,
    timeAnalyzed,
    image,
    language,
    isFetching
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <span className="icon icon-source" />
                Publisher
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLineLength={20}
                maxLineLength={50}
            >
                <p>{publisher || "No publisher"}</p>
            </ContentLoaderLines>
            <div className="source-info">
                <ContentLoaderLines isFetching={isFetching}>
                    <a
                        href={link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {link}
                    </a>
                </ContentLoaderLines>
            </div>
            <h3>
                <span className="icon icon-headline" />
                Headline
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLines={1}
                maxLines={2}
            >
                <p>{title || "No title"}</p>
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-headline" />
                Publishing time
            </h3>
            <ContentLoaderLines isFetching={isFetching} lineLength={40}>
                <p>{time && time.local().format("llll")}</p>
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-headline" />
                Added on
            </h3>
            <ContentLoaderLines isFetching={isFetching} lineLength={40}>
                <p>
                    {timeAnalyzed &&
                        timeAnalyzed.local().format("llll")}
                </p>
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-lang" />
                Language
            </h3>
            <ContentLoaderLines isFetching={isFetching} lineLength={20}>
                <p>
                    {(languageCodeMapping[language] || {}).name ||
                        "unknown language"}
                </p>
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-heroimg" />
                Hero image
            </h3>
            <BackgroundImage
                imageUrl={image}
                classList={["item-background-image"]}
            />
        </div>
    </div>
)

export default ViewFeedItemPublishingDetails
